export default __webpack_public_path__ + "static/media/Arena.d2128672.png";